// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom'; // Use Link for navigation if using React Router
import './Navbar.css'; // Import CSS for styling

const Navbar = () => {
  return (
    <nav className="navbar">
      <ul className="navbar-links">
        <li>
          <Link to="/tree">see tree.</Link>
        </li>
        <li>
          <Link to="/add-ornament">add ornament.</Link>
        </li>
        <li>
          <Link to="/notes">notes.</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;

